<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">A cumplimentar sólo en el caso de EXTERNALIZACIONES/CONTRATOS</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="contract_amount_excl_vat">Importe contrato (IVA Excluído)</label>
            <input
              :value="localResume.contract_amount_excl_vat"
              @input="$emit('update:field', 'contract_amount_excl_vat', $event.target.value)"
              @blur="v.contract_amount_excl_vat && v.contract_amount_excl_vat.$touch()"
              type="number"
              step="0.01"
              class="form-control"
              :class="{ 'is-invalid': v.contract_amount_excl_vat && v.contract_amount_excl_vat.$error }"
              id="contract_amount_excl_vat"
              placeholder="0.00"
            />
            <div v-if="v.contract_amount_excl_vat && v.contract_amount_excl_vat.$error" class="invalid-feedback">
              <div v-if="!v.contract_amount_excl_vat.decimal">Debe ser un número decimal válido</div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="award_procedure">Procedimiento de adjudicación</label>
            <input
              :value="localResume.award_procedure"
              @input="$emit('update:field', 'award_procedure', $event.target.value)"
              type="text"
              class="form-control"
              id="award_procedure"
              placeholder="Procedimiento de adjudicación"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="procurement_file_number">Nº expediente de contratación</label>
            <input
              :value="localResume.procurement_file_number"
              @input="$emit('update:field', 'procurement_file_number', $event.target.value)"
              type="text"
              class="form-control"
              id="procurement_file_number"
              placeholder="Nº expediente"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-group">
            <label for="budget_chapter">Capítulo presupuestario</label>
            <input
              :value="localResume.budget_chapter"
              @input="$emit('update:field', 'budget_chapter', $event.target.value)"
              type="text"
              class="form-control"
              id="budget_chapter"
              placeholder="Capítulo presupuestario"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExternalizationsSection",
  props: {
    localResume: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },
};
</script>
